// =============================================================================
// src/views/workspace/workspace-detail-render.ts — Painel de detalhe do Workspace.
//
// Popula o painel direito a partir da análise selecionada: título, compartilhamento,
//   criado/camadas/vistas e o feed "Atividade recente" (#u-ws-activity reconstruído
//   por nós DOM — textContent, sem escape manual). Guard clauses em cada alvo para
//   tolerar markup parcial (testes e re-render).
//
// SRP: só escrita do painel de detalhe. Markup base em index.ts; dados no store.
// =============================================================================

import type { WorkspaceActivityEntry, WorkspaceAnalysis } from './workspace-types';
import { qs } from '../../app/dom';

/** Atualiza todo o painel de detalhe; no-op se não há análise selecionada. */
export function applyDetailPanel(analysis: WorkspaceAnalysis | null): void {
  if (!analysis) return;
  setText('#u-ws-detail-title', analysis.title);
  applyShare(analysis.share);
  setText('#u-ws-created', analysis.created);
  setText('#u-ws-layers', analysis.layers);
  setText('#u-ws-views', analysis.views);
  applyActivity(analysis.activity);
}

/** Escreve textContent num alvo, se existir. */
function setText(selector: string, text: string): void {
  const target = qs(selector);
  if (target) target.textContent = text;
}

/** Reconstrói a linha de compartilhamento (ícone + rótulo). */
function applyShare(share: string): void {
  const target = qs('#u-ws-detail-share');
  if (!target) return;
  target.replaceChildren(makeIcon('ti-users', '12px'), document.createTextNode(` ${share}`));
}

/** Reconstrói o feed de atividade a partir das entradas da análise. */
function applyActivity(activity: readonly WorkspaceActivityEntry[]): void {
  const target = qs('#u-ws-activity');
  if (!target) return;
  target.replaceChildren(...activity.map(renderActivityRow));
}

/** Uma linha do feed: ator (negrito) + detalhe (secundário). */
function renderActivityRow(entry: WorkspaceActivityEntry): HTMLElement {
  const row = document.createElement('div');
  row.style.cssText = 'font-size:11px;padding:4px 0;border-bottom:0.5px solid var(--color-border-tertiary)';
  row.append(
    makeLine(entry.actor, 'color:var(--color-text-primary);font-weight:500'),
    makeLine(entry.detail, 'color:var(--color-text-secondary);font-size:10px'),
  );
  return row;
}

/** Cria um <div> com texto e estilo inline. */
function makeLine(text: string, cssText: string): HTMLElement {
  const line = document.createElement('div');
  line.style.cssText = cssText;
  line.textContent = text;
  return line;
}

/** Cria um <i> de ícone Tabler com tamanho dado. */
function makeIcon(iconName: string, fontSize: string): HTMLElement {
  const icon = document.createElement('i');
  icon.className = `ti ${iconName}`;
  icon.style.fontSize = fontSize;
  return icon;
}
